import React from 'react';
import { FiAward, FiBookOpen, FiTarget, FiGitPullRequest } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const features = [
    {
        icon: <FiAward size={32} className="text-blue-500" />,
        title: "College Ranking",
        desc: "Based on 2024 Data",
        link: "/CollegRanking",
        borderColor: "border-blue-100",
        bgIcon: "bg-blue-50"
    },
    {
        icon: <FiBookOpen size={32} className="text-orange-500" />,
        title: "Explore Programs",
        desc: "B.Tech, MBA, MBBS",
        link: "/programs",
        borderColor: "border-orange-100",
        bgIcon: "bg-orange-50"
    },
    {
        icon: <FiTarget size={32} className="text-purple-500" />,
        title: "College Predictor",
        desc: "Know your chances",
        link: "/college-predictor",
        borderColor: "border-purple-100",
        bgIcon: "bg-purple-50"
    },
    {
        icon: <FiGitPullRequest size={32} className="text-green-500" />,
        title: "Compare Colleges",
        desc: "Side by side check",
        link: "/compare",
        borderColor: "border-green-100",
        bgIcon: "bg-green-50"
    }
];

const FeaturesSection = () => {
    return (
        <section className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-800">Explore Our Features</h2>
                    <div className="w-24 h-1 bg-brand-orange mx-auto mt-4 rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <Link to={feature.link} key={index} className="group">
                            <div className={`bg-white border ${feature.borderColor} rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col items-center text-center`}>
                                <div className={`${feature.bgIcon} p-5 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                                    {feature.icon}
                                </div>
                                <h3 className="text-xl font-bold text-gray-800 mb-2">{feature.title}</h3>
                                <p className="text-gray-500 text-sm">{feature.desc}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
